import * as React from "react"
import styled from "styled-components"
import { mbGbDisplay } from "../../utils/helpers"
import { ReportData } from ".."
import { ReportText } from "./ReportText"

export type DetailProperty =
  | {
      name: string
      value: number
      precision: number
      unit: string
    }
  | {
      name: string
      value: number
      type: "data"
    }
  | {
      name: string
      value: string
      type: "text" | "date"
    }

const DottedUnderline = styled.div`
  border-bottom: ${(props) => `1px dotted ${props.theme.colors.greyDark}`};
  margin-bottom: 2px;
  margin-inline: 0.5ch;
  flex-grow: 1;
`

const DetailDataLine = styled.div`
  display: flex;
  margin-bottom: 0.5em;
`

export const reportDetailsFromData = (data: ReportData, before: DetailProperty[] = []): DetailProperty[] => {
  let details = [...before]

  if (data.type === "dataplan") {
    details = details.concat([
      {
        name: "Total Data Usage",
        value: data.dataPlan.totalDataUsage!,
        type: "data",
      },
      {
        name: "Total Allowed Data Usage",
        value: data.dataPlan.volumeAllowedAggregated!,
        type: "data",
      },
      {
        name: "Subscription Activated",
        value: data.dataPlan.start,
        type: "date",
      },
      {
        name: "Subscription End",
        value: data.dataPlan.end,
        type: "date",
      },
    ])
  }

  if (data.type === "group") {
    details = details.concat([
      {
        name: "Group Name",
        type: "text",
        value: data.group.name,
      },
      {
        name: "Organization",
        type: "text",
        value: data.group.organization.name,
      },
    ])
  }

  return details
}

/**
 * Returns formatted report data value for report details
 */
const formattedDetailValue = (property: DetailProperty): string => {
  if (property.value == undefined || (typeof property.value === "number" && isNaN(property.value))) {
    return "None"
  }

  if ("precision" in property) {
    return `${(property.value * 100).toFixed(property.precision)} ${property.unit}`
  }

  if (property.type === "data") {
    return mbGbDisplay(property.value)
  }

  if (property.type === "date") {
    const date = new Date(property.value)
    if (!isNaN(date.getTime())) {
      return date.toLocaleString()
    }
  }

  return property.value
}

const ReportDetails: React.FC<{ details: DetailProperty[] }> = ({ details }) => {
  return (
    <div>
      {details.map((detail) => (
        <DetailDataLine key={detail.name}>
          <ReportText>{detail.name}</ReportText>
          <DottedUnderline />
          <ReportText>{formattedDetailValue(detail)}</ReportText>
        </DetailDataLine>
      ))}
    </div>
  )
}

export default ReportDetails
